(function () {
  function waitForImages(root) {
    var images = Array.prototype.slice.call(root.querySelectorAll('img'));
    if (!images.length) return Promise.resolve();

    return Promise.all(
      images.map(function (img) {
        if (img.complete && img.naturalWidth > 0) return Promise.resolve();
        if (typeof img.decode === 'function') {
          return img.decode().catch(function () {
            return new Promise(function (resolve) {
              img.addEventListener('load', resolve, { once: true });
              img.addEventListener('error', resolve, { once: true });
            });
          });
        }
        return new Promise(function (resolve) {
          img.addEventListener('load', resolve, { once: true });
          img.addEventListener('error', resolve, { once: true });
        });
      })
    );
  }

  function clearClones(track, sourceSet) {
    track.querySelectorAll('[data-logo-scroll-set-clone]').forEach(function (el) {
      el.remove();
    });
    sourceSet.querySelectorAll('[data-logo-scroll-clone]').forEach(function (el) {
      el.remove();
    });
  }

  function fillSetToViewport(sourceSet, minWidth) {
    var baseItems = sourceSet.querySelectorAll(
      '.logo-list-scroll-cottolio__item:not([data-logo-scroll-clone])'
    );
    if (!baseItems.length) return;

    // Fill to a bit more than viewport so the loop seam never flashes empty.
    var targetWidth = Math.max(minWidth * 1.5, minWidth + 1);
    var safety = 0;

    while (sourceSet.scrollWidth < targetWidth && safety < 24) {
      baseItems.forEach(function (item) {
        var clone = item.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('data-logo-scroll-clone', '');
        sourceSet.appendChild(clone);
      });
      safety += 1;
    }
  }

  function initLogoListScroll(section) {
    var marquee = section.querySelector('.logo-list-scroll-cottolio__marquee');
    if (!marquee) return;

    var track = marquee.querySelector('.logo-list-scroll-cottolio__track');
    var sourceSet = track && track.querySelector('[data-logo-scroll-set]');
    if (!sourceSet) return;

    track.classList.remove('is-ready');
    clearClones(track, sourceSet);

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      track.classList.add('is-ready');
      return;
    }

    var baseItems = sourceSet.querySelectorAll(
      '.logo-list-scroll-cottolio__item:not([data-logo-scroll-clone])'
    );
    if (!baseItems.length) return;

    waitForImages(sourceSet).then(function () {
      // Section may have been removed/re-rendered while images loaded.
      if (!document.contains(sourceSet) || !document.contains(track)) return;

      clearClones(track, sourceSet);

      var minWidth = marquee.clientWidth || marquee.offsetWidth;
      if (!minWidth) {
        track.classList.add('is-ready');
        return;
      }

      fillSetToViewport(sourceSet, minWidth);

      var duplicateSet = sourceSet.cloneNode(true);
      duplicateSet.setAttribute('aria-hidden', 'true');
      duplicateSet.removeAttribute('data-logo-scroll-set');
      duplicateSet.setAttribute('data-logo-scroll-set-clone', '');
      track.appendChild(duplicateSet);

      // Next frame: enable animation only after layout with both sets is ready.
      requestAnimationFrame(function () {
        if (!document.contains(track)) return;
        track.classList.add('is-ready');
      });
    });
  }

  function initAllLogoListScroll(root) {
    (root || document).querySelectorAll('.logo-list-scroll-cottolio').forEach(initLogoListScroll);
  }

  var resizeTimer;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      initAllLogoListScroll();
    }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllLogoListScroll();
      window.addEventListener('resize', onResize);
    });
  } else {
    initAllLogoListScroll();
    window.addEventListener('resize', onResize);
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('.logo-list-scroll-cottolio')) {
      initAllLogoListScroll(event.target);
    }
  });
})();
